<template>
  <div id="CommonTabbar">
    <van-tabbar v-model="tabbarIndex">
      <van-tabbar-item icon="home-o" to="/">首页</van-tabbar-item>
      <van-tabbar-item icon="shop-o" to="/brand/index">品牌</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
    name: 'CommonTabbar',
    props: ['tabbarActive'],
    data() {
        return {
          tabbarIndex: 0
        }
    },
    mounted() {
      this.tabbarIndex = this.tabbarActive
    }
}
</script>